import { getStateProperty } from "@/utils/store";
import * as types from "./mutations-types";

interface State {
  error: any;
  [key: string]: {
    loading?: boolean;
    model?: any;
    list?: any[];
    params?: Record<string, any>;
    [key: string]: any;
  };
}

interface ModelPayload {
  name: string;
  model: any;
}

interface ListPayload {
  name: string;
  list: any[];
}

interface ListItemPayload {
  name: string;
  index: number;
  value: any;
}

interface ParamsPayload {
  name: string;
  params: Record<string, any>;
}

export default {
  [types.SET_ERROR]: (state: State, error: any) => {
    state.error = error;
  },
  [types.LOADING]: (state: State, name: string) => {
    const property = getStateProperty(state, name);
    property.loading = true;
  },
  [types.LOADED]: (state: State, name: string) => {
    const property = getStateProperty(state, name);
    property.loading = false;
  },
  [types.SET_MODEL]: (state: State, { name, model }: ModelPayload) => {
    const property = getStateProperty(state, name);
    property.model = model;
  },
  [types.UPDATE_MODEL]: (state: State, { name, model }: ModelPayload) => {
    const property = getStateProperty(state, name);
    property.model = { ...property.model, ...model };
  },
  [types.SET_LIST]: (state: State, { name, list }: ListPayload) => {
    const property = getStateProperty(state, name);
    property.list = list;
  },
  [types.ADD_LIST_ITEMS]: (state: State, { name, list }: ListPayload) => {
    const property = getStateProperty(state, name);
    property.list = property.list.concat(list);
  },
  [types.UPDATE_LIST_ITEM]: (state: State, { name, index, value }: ListItemPayload) => {
    const property = getStateProperty(state, name);
    Object.assign(property.list[index], value);
  },
  [types.SET_PARAMS]: (state: State, { name, params }: ParamsPayload) => {
    const property = getStateProperty(state, name);
    property.params = params;
  },
  [types.UPDATE_PARAMS]: (state: State, { name, params }: ParamsPayload) => {
    const property = getStateProperty(state, name);
    property.params = { ...property.params, ...params };
  },
};
